/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse, 
  HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

import { AutoTest } from '../models/auto-test';
import { AutoStep } from '../models/auto-step';


@Injectable()
export class AutoTestsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param year - undefined
   * @param page - undefined
   * @param limit - undefined
   */
  getAutoTestsResponse(params: AutoTestsService.GetAutoTestsParams): Observable<HttpResponse<AutoTest[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.year != null) __params = __params.set("year", params.year.toString());
    if (params.page != null) __params = __params.set("page", params.page.toString());
    if (params.limit != null) __params = __params.set("limit", params.limit.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/admin/auto-test`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: AutoTest[] = null;
        _body = _resp.body as AutoTest[]
        return _resp.clone({body: _body}) as HttpResponse<AutoTest[]>;
      })
    );
  }

  /**
   * @param year - undefined
   * @param page - undefined
   * @param limit - undefined
   */
  getAutoTests(params: AutoTestsService.GetAutoTestsParams): Observable<AutoTest[]> {
    return this.getAutoTestsResponse(params).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param autoTestId - undefined
   */
  getAutoStepByAutoTestIdResponse(autoTestId: number): Observable<HttpResponse<AutoStep>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/admin/auto-step/${autoTestId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: AutoStep = null;
        _body = _resp.body as AutoStep
        return _resp.clone({body: _body}) as HttpResponse<AutoStep>;
      })
    );
  }

  /**
   * @param autoTestId - undefined
   */
  getAutoStepByAutoTestId(autoTestId: number): Observable<AutoStep> {
    return this.getAutoStepByAutoTestIdResponse(autoTestId).pipe(
      map(_r => _r.body)
    );
  }}

export module AutoTestsService {
  export interface GetAutoTestsParams {
    year?: number;
    page?: number;
    limit?: number;
  }
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/services/auto-tests.service.ts